"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.regexp.to-string");

var _toConsumableArray2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray"));

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _LangSelect = _interopRequireDefault(require("@/components/LangSelect"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _encryption = require("@/utils/encryption");

var _axios = _interopRequireDefault(require("axios"));

var _vuex = require("vuex");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import localStorage from "js-cookie";
var _default = {
  name: "Login",
  components: {
    LangSelect: _LangSelect.default
  },
  data: function data() {
    return {
      versionNumber: process.env.VUE_APP_VERSION_NUMBER,
      mode: this.$route.meta.mode,
      remember: false,
      key: null,
      src: null,
      loginForm: {
        userAccount: "",
        password: "",
        verifyCode: "",
        webVerifyCode: "",
        key: "",
        domainName: "",
        endType: 1
      },
      passwordType: "password",
      capsTooltip: false,
      loading: false,
      redirect: undefined,
      otherQuery: {},
      checked: true,
      image: "",
      defaultImage: "default.png",
      logo: {
        logoPath: "",
        logoWidth: 0,
        logoHeight: 0
      },
      ip: "",
      pageLoad: false,
      // 0 => not loaded
      // 1 => loaded successfully
      // -1 => loading
      // -2 => fail to load
      fetchingMerchantLogo: 0,
      merchantLogo: ''
    };
  },
  watch: {
    $route: {
      handler: function handler(route) {
        var query = route.query;

        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }

        this.mode = route.meta.mode;
        this.refreshData();

        if (this.mode === 'admin') {
          document.title = this.$store.getters.title;
        }
      },
      immediate: true
    }
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.dispatch('user/resetToken');

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  beforeDestroy: function beforeDestroy() {
    this.image = "";
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['simplifiedChineseAreaOption', 'traditionalChineseAreaOption', 'languageOption']), {
    hostname: function hostname() {
      return window.location.hostname;
    },
    logoSrc: function logoSrc() {
      var src = '';
      src = this.logoUrl(this.logo.logoPath);
      if (!this.isAdmin && this.merchantLogo) src = this.merchantLogo;
      return src;
    },
    errorInfo: function errorInfo() {
      return {
        email: this.$t('login.emailError'),
        password: this.$t('login.passwordError')
      };
    },
    loginRules: function loginRules() {
      var _this2 = this;

      var validateUsername = function validateUsername(rule, value, callback) {
        if (value.length < 4) {
          callback(new Error(_this2.errorInfo.email));
        } else {
          callback();
        }
      };

      var validatePassword = function validatePassword(rule, value, callback) {
        if (value.length < 1) {
          callback(new Error(_this2.errorInfo.password));
        } else {
          callback();
        }
      };

      return {
        userAccount: [{
          required: true,
          trigger: "change",
          validator: validateUsername
        }],
        password: [{
          required: true,
          trigger: "change",
          validator: validatePassword
        }]
      };
    },
    isAdmin: function isAdmin() {
      return this.mode === "admin";
    },
    isAgent: function isAgent() {
      return this.mode === "agent";
    },
    isMerchant: function isMerchant() {
      return this.mode === "merchant";
    },
    headline: function headline() {
      if (this.isAdmin) {
        return this.$t('login.titleAdmin');
      } else if (this.isAgent) {
        return this.$t('login.titleAgent');
      } else if (this.isMerchant) {
        return this.$t('login.titleMerchant');
      } else {
        return '';
      }
    }
  }),
  methods: {
    getLanguageType: function getLanguageType(area) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.traditionalChineseAreaOption[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (area.search(item.name) != -1) {
            return "zh_TW";
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.simplifiedChineseAreaOption[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _item = _step2.value;

          if (area.search(_item.name) != -1) {
            return "zh_CN";
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return "en";
    },
    backgroundUrl: function backgroundUrl(imgFileName) {
      var bgImgUrl = 'backgroundPayCenter.jpg'; // Admin default backgrounds image // backgroundAdmin => backgroundPayCenter

      if (!this.isAdmin) {
        bgImgUrl = imgFileName;
      }

      try {
        if (bgImgUrl.startsWith('http')) {
          return bgImgUrl;
        } else {
          return require("../../assets/backgrounds/".concat(bgImgUrl || this.defaultImage));
        }
      } catch (e) {
        console.log(e);
        return require("../../assets/backgrounds/".concat(this.defaultImage));
      }
    },
    logoUrl: function logoUrl(imgFileName) {
      try {
        return require("../../assets/logos/".concat(imgFileName));
      } catch (e) {
        console.log(e);
        this.logo.logoPath = "";
      }
    },
    initParams: function initParams(config) {
      this.logo = {
        logoPath: config.logoPath,
        logoWidth: parseInt(config.logoWidth),
        logoHeight: parseInt(config.logoHight)
      };
      this.setImage(config.bgPath);
      this.defaultImage = config.bgPath;
    },
    initLanguageAndIp: function initLanguageAndIp(config) {
      if (!this.$store.getters.isInternational) {
        this.$i18n.locale = "zh_CN";
        this.$store.dispatch("app/setLanguage", "zh_CN");
        var ip = config.ip;
        localStorage.setItem("ip", ip);
        return;
      }

      if (localStorage.getItem("ip") === null || localStorage.getItem("ip") === undefined) {
        var _ip = config.ip;
        localStorage.setItem("ip", _ip);
      }

      if (localStorage.getItem("language") === null || localStorage.getItem("language") === undefined) {
        var city = config.city;
        var language = this.getLanguageType(city);
        this.$i18n.locale = language;
        this.$store.dispatch("app/setLanguage", language);
      }
    },
    getParams: function getParams() {
      var _this3 = this;

      // localStorage-on-Login [DISABLED]
      // let config = this.$store.getters.config;
      // if (Object.keys(config).length) {
      //   this.initParams(config)
      //   return
      // }
      return new Promise(function (resolve, reject) {
        var _this = _this3; // let code = this.$store.getters.language;

        _httpUtils.default.post("HomeData", "parameters", null, null).then(function (res) {
          var data = (0, _toConsumableArray2.default)(res); // TESTING
          // res[0].name = 'logoHG.jpg'
          // data[0].name = 'logoHG.jpg'

          _this.$store.dispatch('app/setConfig', res); // refactor data structure


          var result = {};

          for (var i = 0; i < data.length; i++) {
            if (data[i]) result[data[i].code] = data[i].name;
          }

          _this.$store.dispatch('app/setPlatform', result.platfromType);

          document.title = result.platformName;

          _this.initLanguageAndIp(result);

          _this.initParams(result);
        }).catch(function (err) {
          console.log(err);

          _this.setImage(_this.defaultImage);
        }).finally(function () {
          resolve();
        });
      });
    },
    getEnums: function getEnums() {
      var _this = this;

      _httpUtils.default.post("rechargeOrder", "getNetwayCodeEnums", null, null).then(function (res) {
        localStorage.setItem("netwayCodeEnums", JSON.stringify(res.data));
      }).catch(function (err) {
        console.log(err);

        _this.setImage(_this.defaultImage);
      });
    },
    getCode: function getCode() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        _this4.src = "";

        _httpUtils.default.get("login", "images/captcha", {
          key: _this4.key
        }, {
          responseType: "arraybuffer"
        }).then(function (res) {
          var decoded = Buffer.from(res, "binary").toString("base64");
          _this4.src = "data:image/png;base64," + decoded;
        }).catch(function (err) {
          console.log(err);
        }).finally(function () {
          resolve();
        });
      });
    },
    refreshData: function refreshData() {
      var _this5 = this;

      this.pageLoad = true;
      this.$nextTick(
      /*#__PURE__*/
      (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this5.key = new Date().getTime();

                _this5.decryptCredentials();

                _this5.getEnums();

                _context2.next = 5;
                return _this5.getParams();

              case 5:
                _this5.$store.dispatch("app/setMode", _this5.mode);

                if (_this5.isAdmin) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 9;
                return _this5.getMerchantLogo();

              case 9:
                _context2.next = 11;
                return _this5.getCode();

              case 11:
                _this5.pageLoad = false; // if (!this.isAdmin) this.$nextTick(() => this.getCode());

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    },
    merchLogoCached: function merchLogoCached() {
      var merch_logo = localStorage.getItem('merch_logo');
      if (merch_logo) return (0, _encryption.decode)(merch_logo);
      return false;
    },
    checkCapslock: function checkCapslock() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          shiftKey = _ref2.shiftKey,
          key = _ref2.key;

      if (key && key.length === 1) {
        this.capsTooltip = shiftKey && key >= "a" && key <= "z" || !shiftKey && key >= "A" && key <= "Z";
      }

      if (key === "CapsLock" && this.capsTooltip === true) {
        this.capsTooltip = false;
      }
    },
    showPwd: function showPwd() {
      var _this6 = this;

      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }

      this.$nextTick(function () {
        _this6.$refs.password.focus();
      });
    },
    setImage: function setImage(img) {
      this.imageUrl = this.backgroundUrl(img);
      this.image = this.imageUrl; // let that = this;
      // let highResImage = new Image();
      // highResImage.onload = function () {
      //   that.image = that.imageUrl;
      // };
      // highResImage.src = this.imageUrl;
    },
    handleLogin: function handleLogin() {
      var _this7 = this;

      this.$refs.loginForm.validate(function (valid) {
        if (valid && !_this7.loading) {
          var _this = _this7;
          _this7.loading = true;
          _this7.loginForm.key = _this7.key.toString();
          _this7.loginForm.domainName = window.location.hostname;

          _this7.$store.dispatch("user/login", _this7.loginForm).then(function () {
            if (_this.remember) _this.encryptCredentials();

            _this.$nextTick(function () {
              _this7.$router.push({
                path: _this7.redirect || "/",
                query: _this7.otherQuery
              });

              _this7.loading = false;
            });
          }).catch(function (err) {
            console.log(err);
            setTimeout(function () {
              _this7.getCode();

              _this7.loginForm.webVerifyCode = "";

              _this7.$notify.error(err);

              _this7.loading = false;
            }, 2000);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getMerchantLogo: function getMerchantLogo() {
      var _this8 = this;

      return new Promise(function (resolve, reject) {
        _this8.fetchingMerchantLogo = -1;

        _httpUtils.default.get("agentSystemConfig", "getAgentLogo", {
          domainName: _this8.hostname
        }).then(function (res) {
          var _res$data = res.data,
              backgroundImage = _res$data.backgroundImage,
              logoImage = _res$data.logoImage,
              platformName = _res$data.platformName;
          _this8.merchantLogo = logoImage;
          var merch_logo = (0, _encryption.encode)(_this8.merchantLogo);
          localStorage.setItem('merch_logo', merch_logo);
          document.title = platformName;

          _this8.setImage(backgroundImage);

          _this8.$store.dispatch('app/setMerchLogo', merch_logo);

          _this8.fetchingMerchantLogo = 1;
        }).catch(function (err) {
          _this8.fetchingMerchantLogo = -2;

          _this8.setImage(_this8.$store.getters.config.bgPath || _this8.defaultImage);
        }).finally(function () {
          resolve();
        });
      });
    },
    getOtherQuery: function getOtherQuery(query) {
      return Object.keys(query).reduce(function (acc, cur) {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }

        return acc;
      }, {});
    },
    encryptCredentials: function encryptCredentials() {
      var combined = "".concat(this.loginForm.userAccount, "<>").concat(this.loginForm.password);
      var encrypted = (0, _encryption.encode)(combined);
      localStorage.setItem("remember_me", encrypted);
    },
    decryptCredentials: function decryptCredentials() {
      var data = localStorage.getItem("remember_me");

      if (data) {
        var result = (0, _encryption.decode)(data).split("<>");
        this.loginForm.userAccount = result[0];
        this.loginForm.password = result[1];
      }
    }
  }
};
exports.default = _default;